import { getQueueDefaultPeriod } from '@/features/billing/utils/period';
import { parseEnumFilter, parseNumberFilter, toFilterText } from '@/utils/filters';
import type { DcrApproveSearch } from '../types/dcrApprove.types';

const YES_NO_FLAGS = ['true', 'false'] as const;

export function toDcrApproveFilterValues(search: DcrApproveSearch): Record<string, string> {
  const defaultPeriod = getQueueDefaultPeriod();
  return {
    dateFrom: search.dateFrom ?? defaultPeriod.dateFrom,
    dateTo: search.dateTo ?? defaultPeriod.dateTo,
    dcrNo: toFilterText(search.dcrNo),
    userId: toFilterText(search.userId),
    dcrTypeId: toFilterText(search.dcrTypeId),
    fiscalYearId: toFilterText(search.fiscalYearId),
    approveTypeNo: toFilterText(search.approveTypeNo),
    isVerify: toFilterText(search.isVerify),
    instituteTypeId: toFilterText(search.instituteTypeId),
    transportTypeId: toFilterText(search.transportTypeId),
    approveTransportTypeId: toFilterText(search.approveTransportTypeId),
    isManualEntry: search.isManualEntry ?? '',
    isRefZm: search.isRefZm ?? '',
  };
}

export function toDcrApproveFilterSearch(values: Record<string, string>): DcrApproveSearch {
  return {
    dateFrom: values.dateFrom || undefined,
    dateTo: values.dateTo || undefined,
    dcrNo: parseNumberFilter(values.dcrNo),
    userId: parseNumberFilter(values.userId),
    dcrTypeId: parseNumberFilter(values.dcrTypeId),
    fiscalYearId: parseNumberFilter(values.fiscalYearId),
    approveTypeNo: parseNumberFilter(values.approveTypeNo),
    isVerify: parseNumberFilter(values.isVerify),
    instituteTypeId: parseNumberFilter(values.instituteTypeId),
    transportTypeId: parseNumberFilter(values.transportTypeId),
    approveTransportTypeId: parseNumberFilter(values.approveTransportTypeId),
    isManualEntry: parseEnumFilter(values.isManualEntry, YES_NO_FLAGS),
    isRefZm: parseEnumFilter(values.isRefZm, YES_NO_FLAGS),
  };
}
